import { fileIndex } from './types.js';
/**
 * True iff moving `piece` from→to is a pawn promotion.
 *
 * A promotion is a pawn advancing from the rank adjacent to its promotion rank
 * onto the promotion rank (7→8 for White, 2→1 for Black), at most one file
 * over — a straight push or a diagonal capture.
 *
 * Checking only the piece type and the destination rank — as the move-commit
 * paths previously did — wrongly flags e.g. a pawn on the 2nd rank "moved" to
 * the 8th, popping the promotion dialog for a move no pawn could ever make.
 */
export function isPromotionMove(piece, from, to) {
    if (!piece || piece.type !== 'p')
        return false;
    if (Math.abs(fileIndex(from) - fileIndex(to)) > 1)
        return false;
    if (piece.color === 'w')
        return from[1] === '7' && to[1] === '8';
    return from[1] === '2' && to[1] === '1';
}
